import {cs}          from "../../react/chain-services";
import {fragments}   from "../../react/fragments";
import {Invoke}      from "../../react/invoke";
import {Static2}     from "../../react/static-2";
import {UseState}    from "../../react/use-state";
import {waitTimeout} from "../../utils/wait-timeout";

import {DownwardTransitioning} from "./downward-transitioning";

export const ModalState = ({initShow=undefined, next: rootNext, state: liftedState = null, renderUI, onClose=undefined, autoRender=true}) => cs(
    ["promiseResolve", (_, next) => Static2({next})],
    ["state", (_, next) => liftedState ? next(liftedState) : UseState({next, initValue: {showing: false, params: null}})],
    ({promiseResolve, state}) => {
        const render = () => cs(
            ["transitioning", (_, next) => DownwardTransitioning({
                value: state.value.showing,
                next,
            })],
            ({transitioning}, next) => (transitioning.active || state.value.showing) && next(),
            ({transitioning}) => {
                const close = async (value) => {
                    const hide = await onClose?.();
                    if (hide !== false) {
                        state.onChange({showing: false, params: state.value.params});
                        await waitTimeout(400);
                        promiseResolve.get()?.(value);
                        return true;
                    }
                    return false;
                };
                return renderUI({
                    transitioning,
                    close,
                    params: state.value.params,
                });
            }
        );

        return fragments(
            rootNext({
                show: (params = null, showing = true) => new Promise((resolve) => {
                    promiseResolve.set(resolve);
                    state.onChange({showing, params});
                }),
                hide: (params = null, showing = false) => new Promise((resolve) => {
                    promiseResolve.set(resolve);
                    state.onChange({showing, params});
                }),
                render: () => !autoRender && render(),
                ...state.value
            }),
            !!initShow && (
                Invoke({
                    action: () => {
                        state.onChange({showing: true, params: initShow});
                    },
                })
            ),
            autoRender && render(),
        );
    },
);
